// @flow
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Tooltip, Typography} from '@material-ui/core';
import {InfoOutlined} from '@material-ui/icons';
import {colors} from '../../../../assets/styles/colors';

type Props = {};

const useStyles = makeStyles(theme => ({
  containerTable: {
    margin: '1rem 0',
    width: '100%',
    borderRadius: '10px',
    border: '1px solid #E9E9EC',
    flexDirection: 'column',
  },
  subTitle: {
    color: '#3A3A49',
    fontWeight: 600,
    fontSize: '18px',
  },
  rowPoints: {
    padding: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    '&:nth-child(2n+1)': {
      backgroundColor: '#F9F9FB',
    },
  },
  text: {
    color: '#353640',
    fontSize: '14px',
    fontWeight: 500,
  },
  wrapperTitle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  infoTooltip: {
    color: colors.purple3,
    backgroundColor: colors.lightPurple,
    borderRadius: '8px',
    textAlign: 'center',
    maxWidth: 240,
  },
  infoIcon: {
    color: '#B8B8C7',
  },
  tooltipContainer: {},
  tooltipText: {
    color: '#7B39FF',
    fontSize: '12px',
    margin: theme.spacing(1, 0, 1, 0),
    letterSpacing: '0.005em',
    textAlign: 'left',
    fontWeight: 500,
  },
}));

const TABLE_POINTS = [
  {
    label: 'Sube primer producto',
    points: '1',
  },
  {
    label: 'Genera su primera venta',
    points: '5',
  },
  {
    label: 'Suscripción a PRO +',
    points: '40',
  },
];
export default function TablePoints(props: Props) {
  const classes = useStyles();

  return (
    <>
      <div className={classes.wrapperTitle}>
        <Typography className={classes.subTitle}>Tabla de puntos</Typography>
        <Tooltip
          classes={{tooltip: classes.infoTooltip}}
          placement="left-start"
          title={
            <div className={classes.tooltipContainer}>
              <Typography className={classes.tooltipText}>
                Gana 1 punto si tu referido consigue subir su primer producto.
              </Typography>
              <Typography className={classes.tooltipText}>
                Gana 5 puntos si tu referido realiza su primera venta.
              </Typography>
              <Typography className={classes.tooltipText}>
                Gana 40 puntos si tu referido se suscribe a PRO.
              </Typography>
            </div>
          }
        >
          <InfoOutlined color="primary" className={classes.infoIcon} />
        </Tooltip>
      </div>
      <div className={classes.containerTable}>
        {TABLE_POINTS.map(desc => (
          <div key={`${desc.label}`} className={classes.rowPoints}>
            <Typography className={classes.text}>{desc.label}</Typography>
            <Typography className={classes.text}>
              {desc.points} punto{Number(desc.points) > 1 ? 's' : ''}
            </Typography>
          </div>
        ))}
      </div>
    </>
  );
}
